import * as React from 'react';
import * as ReactDOM from 'react-dom';
import App from './App';
import { initFullScreenKeyHandler } from "./fullScreenHandler";
import './index.css';
import registerServiceWorker from './registerServiceWorker';

const rootElement = document.getElementById('root');
ReactDOM.render(
  <App />,
  rootElement as HTMLElement
);
registerServiceWorker();
initFullScreenKeyHandler();



// WEBPACK FOOTER //
// ./src/index.tsx